// import { createRouter, createWebHistory } from 'vue-router'
import Vue from "vue";
import VueRouter from "vue-router";
import Connexion from "../views/Connexion";
import MesEvenements from "../views/MesEvenements";
import CreateNew from "../views/CreateNew";
import EditEventPage from "../views/EditEventPage";
import ListingEvenements from "../views/ListingEvenements";
import EvenementPage from "../views/EvenementPage";
import Home from "../views/Home";
import CartePage from "../views/CartePage";
Vue.use(VueRouter)
const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/connexion',
        component: Connexion
    },
    {
        path: '/nouveau-evenement',
        component: CreateNew
    },
    {
        path: '/modification-evenement',
        component: EditEventPage
    },
    {
        path: '/mes-evenements',
        component: MesEvenements
    },
    {
        path: '/carte',
        component: CartePage
    },
    {
        path: '/evenements',
        component: ListingEvenements
    },
    {
        path: '/evenement/:slug',
        component: EvenementPage
    }
]

const router = new VueRouter({
    // base: '/annuaire/',
    mode: 'history',
    routes
})

export default router